import { render } from "./MarketingDatatableTDNotificationDate.vue?vue&type=template&id=42ef742a"
import script from "./MarketingDatatableTDNotificationDate.vue?vue&type=script&lang=js"
export * from "./MarketingDatatableTDNotificationDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__